export const ABOUT_APP_REQUEST = 'ABOUT_APP_REQUEST';
export const ABOUT_APP_REQUEST_SUCCESS = 'ABOUT_APP_REQUEST_SUCCESS';
export const ABOUT_APP_REQUEST_ERROR = 'ABOUT_APP_REQUEST_ERROR';

export const ABOUT_APP_UPDATE = 'ABOUT_APP_UPDATE';
export const ABOUT_APP_UPDATE_SUCCESS = 'ABOUT_APP_UPDATE_SUCCESS';
export const ABOUT_APP_UPDATE_ERROR = 'ABOUT_APP_UPDATE_ERROR';
